import styled from 'styled-components'
import { Form, FormHeader } from '../../Form/styled'

export const StyledForm = styled(Form)`
    max-width: 100%;
`

export const StyledFormHeader = styled(FormHeader)`
    margin-bottom: 30px;
`

export const StyledPeriod = styled.div`
    margin-bottom: 20px;
`

export const StyledPeriodTitle = styled.div`
    padding: 5px 0;
    margin-bottom: 25px;
    border-bottom: ${ ({ theme }) => `1px solid ${theme.veryLightPink}`};
`

export const StyledDateRange = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 25px;
    margin-left: -10px;
    margin-right: -10px;
`

export const StyledDateRangeItem = styled.div`
    flex: 1;
    margin: 0 10px;
`

export const StyledReports = styled.div`
    margin-bottom: 25px;
`

export const StyledReportsTitle = styled.div`
    padding: 5px 0;
    margin-bottom: 25px;
    border-bottom: ${ ({ theme }) => `1px solid ${theme.veryLightPink}`};
`

export const StyledCheckboxWrapper = styled.div`
    margin-bottom: 10px;
`